/**
 * @generated SignedSource<<a4fc9e33ed548b4ea5c8123a402a4221>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SalesforceFieldInteractionType = "AI_SUGGESTION" | "EDITABLE" | "VIEW_ONLY";
export type SalesforceQuery$variables = {
  streamId: string;
};
export type SalesforceQuery$data = {
  readonly salesforceContactsForStream: ReadonlyArray<{
    readonly __typename: "SalesforceObjectRecord";
    readonly fields: ReadonlyArray<{
      readonly interactionType: SalesforceFieldInteractionType;
      readonly label: string;
      readonly length: number | null;
      readonly name: string;
      readonly type: string;
      readonly value: string | null;
    }>;
    readonly id: string;
    readonly label: string;
    readonly name: string;
    readonly references: ReadonlyArray<{
      readonly fields: ReadonlyArray<{
        readonly interactionType: SalesforceFieldInteractionType;
        readonly label: string;
        readonly length: number | null;
        readonly name: string;
        readonly type: string;
        readonly value: string | null;
      }>;
      readonly id: string;
      readonly label: string;
      readonly name: string;
      readonly url: string;
      readonly value: string | null;
    }>;
    readonly url: string;
    readonly value: string | null;
  }> | null;
};
export type SalesforceQuery = {
  response: SalesforceQuery$data;
  variables: SalesforceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesforceFieldData",
  "kind": "LinkedField",
  "name": "fields",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "interactionType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "length",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = [
  {
    "alias": "salesforceContactsForStream",
    "args": [
      {
        "kind": "Variable",
        "name": "streamId",
        "variableName": "streamId"
      }
    ],
    "concreteType": "SalesforceObjectRecord",
    "kind": "LinkedField",
    "name": "salesforceObjectsForStream",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "SalesforceObjectRecord",
        "kind": "LinkedField",
        "name": "references",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SalesforceQuery",
    "selections": (v7/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SalesforceQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "25a708ee0970bfbba7378a646f0caef0",
    "id": null,
    "metadata": {},
    "name": "SalesforceQuery",
    "operationKind": "query",
    "text": "query SalesforceQuery(\n  $streamId: ID!\n) {\n  salesforceContactsForStream: salesforceObjectsForStream(streamId: $streamId) {\n    __typename\n    name\n    label\n    value\n    id\n    url\n    fields {\n      name\n      label\n      value\n      type\n      interactionType\n      length\n    }\n    references {\n      name\n      label\n      value\n      id\n      url\n      fields {\n        name\n        label\n        value\n        type\n        interactionType\n        length\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd3eec6f1389aeacc3f85bf2f978436b";

export default node;
